// extracted by mini-css-extract-plugin
module.exports = {"wrap":"common_wrap_2abvo","fanhui":"common_fanhui_10wcl","btnWrap":"common_btnWrap_3laIC","btn":"common_btn_3kxwy","fullScreen":"common_fullScreen_FlzE6"};